import type { ProfileRedactionConfig } from "../types.js";

function randomBetween(min: number, max: number): number {
    return min + Math.random() * (max - min);
}

function clamp(value: number, min: number, max: number): number {
    return Math.min(max, Math.max(min, value));
}

export function applyProfileRedaction(
    imageData: ImageData,
    config: ProfileRedactionConfig,
): void {
    const { data, width, height } = imageData;
    const y0 = Math.max(0, config.lineStart);
    const y1 = Math.min(height - 1, config.lineEnd);
    const lineJitter = config.lineJitter ?? 0.015;

    const bandStart = randomBetween(config.startMin, config.startMax);
    const bandWidth = randomBetween(config.visibleMin, config.visibleMax);

    for (let y = y0; y <= y1; y++) {
        const startFrac = clamp(
            bandStart + randomBetween(-lineJitter, lineJitter),
            0,
            1,
        );
        const widthFrac = clamp(
            bandWidth + randomBetween(-lineJitter, lineJitter),
            0,
            1 - startFrac,
        );
        const startX = Math.floor(width * startFrac);
        const endX = Math.min(startX + Math.floor(width * widthFrac), width);
        const row = y * width * 4;

        for (let x = startX; x < endX; x++) {
            const i = row + x * 4;
            data[i] = 0;
            data[i + 1] = 0;
            data[i + 2] = 0;
        }
    }
}
